export const TYPE_DEFS = [
  { key: 'deroulant', label: 'Panneaux déroulants', short: 'déroulant', max: 10 },
  { key: 'led', label: 'Panneaux LED', short: 'LED', max: 3 },
  { key: 'grand', label: 'Panneau grand format', short: 'grand format', max: 1 },
  { key: 'poteau', label: 'Panneaux poteaux', short: 'poteau', max: 4 },
];

export const typeKey = (t) => {
  const s = String(t || '').toLowerCase();
  if (s.includes('poteau')) return 'poteau';
  if (s.includes('led')) return 'led';
  if (s.includes('grand')) return 'grand';
  return 'deroulant';
};

export const capaciteFor = (e) => {
  const k = typeKey(e?.type_panneau);
  if (k === 'poteau') return Number(e.capacite_poteaux || 25);
  if (k === 'grand') return 4;
  return 10;
};

const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();

const KEYS = [
  ['pk0', 1], ['pko', 1], ['beac', 2], ['ienerca', 3], ['boganda', 4], ['orange', 4],
  ['cathedrale', 5], ['eglise', 5], ['martyrs', 6], ['hopital', 6], ['communautaire', 6],
  ['lycee francais', 7], ['cdg', 7], ['touadera', 8], ['ambassade', 9], ['usa', 9], ['rn6', 9],
  ['bangui mall', 10], ['bangui-mall', 10], ['gaule', 11], ['oubangui', 11],
  ['aeroport', 12], ['m poko', 12], ['mpoko', 12], ['ledger', 13], ['centre commercial', 14], ['centre commercal', 14],
];

const matchEmp = (emplacements, rawName) => {
  const target = norm(rawName);
  if (!target) return null;
  let best = emplacements.find((e) => norm(e.nom) === target);
  if (best) return best;
  for (const [k, num] of KEYS) {
    if (target.includes(k)) {
      best = emplacements.find((e) => e.numero === num);
      if (best) return best;
    }
  }
  return emplacements.find((e) => target.includes(norm(e.nom)) || norm(e.nom).includes(target)) || null;
};

const lineStart = (c, l) => (l.date_debut || c.date_debut || c.date_signature || c.created_at || '').slice(0, 10);

// Occupation par emplacement à partir des contrats non annulés ; `until` (YYYY-MM-DD) limite aux lignes démarrées avant.
export function computeOccupation(contrats, emplacements, until = null) {
  const counts = new Map(emplacements.map((e) => [e.id, 0]));
  for (const c of contrats) {
    const st = (c.statut || '').toLowerCase();
    if (st.includes('annul') || st.includes('refus') || st.includes('reje')) continue;
    for (const l of c.lignes || []) {
      if (until && lineStart(c, l) > until) continue;
      const affMap = l.affiches_par_emplacement || {};
      const emps = [...(l.emplacements || [])];
      if (l.emplacement && !emps.includes(l.emplacement)) emps.push(l.emplacement);
      const nbTotal = Number(l.nombre_affiches || 0);
      const perEmp = emps.length ? Math.ceil(nbTotal / emps.length) : nbTotal;
      for (const name of emps) {
        const t = matchEmp(emplacements, name);
        if (!t) continue;
        const nb = Number(affMap[name] || perEmp || 1);
        counts.set(t.id, Math.min(capaciteFor(t), (counts.get(t.id) || 0) + nb));
      }
    }
  }
  return counts;
}

// Garde les N premiers emplacements officiels par type (tri numéro puis date de création).
export function officialByType(emplacements) {
  const out = {};
  for (const d of TYPE_DEFS) {
    out[d.key] = emplacements.filter((e) => typeKey(e.type_panneau) === d.key)
      .sort((a, b) => (a.numero || 999) - (b.numero || 999) || String(a.created_at || '').localeCompare(String(b.created_at || '')))
      .slice(0, d.max);
  }
  return out;
}

const MOIS = ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'];

export function occupationEvolution(contrats, emplacements, list, months = 6) {
  const now = new Date();
  const ids = new Set(list.map((e) => e.id));
  const points = [];
  for (let i = months - 1; i >= 0; i -= 1) {
    const d = new Date(now.getFullYear(), now.getMonth() - i + 1, 0);
    const until = i === 0 ? null : `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    const occ = computeOccupation(contrats, emplacements, until);
    let total = 0;
    for (const [id, v] of occ) if (ids.has(id)) total += v;
    points.push({ mois: MOIS[d.getMonth()], value: total });
  }
  return points;
}
